export const MenuItems = [
  {
    title: "Home",
    url: "/",
    CName: "nav-links",
    icon: "fa-solid fa-house-user",
  },

  {
    title: "About Us",
    url: "/about",
    CName: "nav-links",
    icon: "fa-regular fa-address-card",
    ddIcon: "fas fa-caret-down",
  },
];

export const MenuItems1 = [
  {
    title: "Multimedia",
    url: "/multimedia",
    CName: "nav-links",
    icon: "fa-regular fa-file",
    ddIcon: "fas fa-caret-down",
  },
];

export const MenuItems2 = [
  {
    title: "Membership",
    url: "/membership",
    CName: "nav-links",
    icon: "fa-solid fa-user-group",
    ddIcon: "fas fa-caret-down",
  },
  // {
  //   title: "Donate Online",
  //   url: "/payment",
  //   CName: "nav-links",
  //   icon: "fa-solid fa-wifi",
  // },
  {
    title: "Contact Us",
    url: "/contact",
    CName: "nav-links",
    icon: "fa-solid fa-address-book",
  },
];

export const EventDropDownMenu = [
  {
    index: 0,
    title: "About Shikha",
    url: "/aboutShikha",
    CName: "dropdown-links",
  },
  {
    index: 1,
    title: "Shikhaa Lighting Stars",
    url: "/execCommMem",
    CName: "dropdown-links",
  },
  {
    index: 2,
    title: "Constitution and Bylaws",
    url: "/constitution",
    CName: "dropdown-links",
  },
];
export const EventDropDownMenu1 = [
  {
    index: 0,
    title: "Photo Gallery",
    url: "/photoGallery",
    CName: "dropdown-links",
  },
  {
    index: 1,
    title: "Videos",
    url: "/videos",
    CName: "dropdown-links",
  },
  {
    index: 2,
    title: "Bangla Publications",
    url: "/publications",
    CName: "dropdown-links",
  },
];
export const EventDropDownMenu2 = [
  {
    index: 0,
    title: "Become a Member",
    url: "/membershipForm",
    CName: "dropdown-links",
  },
];
